import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const paymentSelector = createFeatureSelector<IState>('payment');
export const getPaymentsSelector = createSelector(paymentSelector, (state: IState) => state); 
export const getPaymentSelector = createSelector(paymentSelector, (state: IState) => state.selectedItem); 
